import React from 'react'
import * as S from '../../styles'

export const ThirdRowWidgets = ({
  devicePolicyAccessState,
  usersAccessState,
  solutionsAccessState,
  renderDevicePolicyStatusWidget,
  renderCustomersUsersStatusWidget,
  renderSolutionsWidget
}) => {
  const renderThirdRow = () => {
    if (devicePolicyAccessState && usersAccessState) {
      return (
        <S.Grid
          leftChildFrWidth={6}
          rightChildFrWidth={6}
        >
          {renderDevicePolicyStatusWidget}
          {renderCustomersUsersStatusWidget}
        </S.Grid>
      )
    }
    if (!devicePolicyAccessState && usersAccessState && solutionsAccessState) {
      return (
        <S.Grid
          leftChildFrWidth={6}
          rightChildFrWidth={6}
        >
          {renderCustomersUsersStatusWidget}
          {renderSolutionsWidget}
        </S.Grid>
      )
    }
    if (devicePolicyAccessState && !usersAccessState && solutionsAccessState) {
      return (
        <S.Grid
          leftChildFrWidth={6}
          rightChildFrWidth={6}
        >
          {renderDevicePolicyStatusWidget}
          {renderSolutionsWidget}
        </S.Grid>
      )
    }
  }

  return <>{renderThirdRow()}</>
}

export default ThirdRowWidgets
